import { render, staticRenderFns } from "./PersonalAbilityRow.vue?vue&type=template&id=0754c58a"
import script from "./PersonalAbilityRow.vue?vue&type=script&lang=js"
export * from "./PersonalAbilityRow.vue?vue&type=script&lang=js"
import style0 from "./PersonalAbilityRow.vue?vue&type=style&index=0&id=0754c58a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports